import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import { Col, Row, Button, Form, InputGroup } from "react-bootstrap";
import MyNavbar from "../component/navbar";
import logo from "../assets/images/logo_large.svg";
import isEmpty from "is-empty";
import { toastAlert } from "../helper/toastAlert"
import { Roller } from "react-awesome-spinners";
import { resetpassword } from "../ApiAction/api"
import { Link, useNavigate, useParams } from "react-router-dom";
import {
    resetValidate, resetInputValidate
} from "../validation/validation"


let initialValue = {
    newpassword: "",
    confirmnewpassword: ""
};

export default function ResetPassword(props) {

    const [userData, setUserData] = useState(initialValue);
    const [error, setError] = useState({});
    const [isLoad, setisLoad] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showconfirmPassword, setShowconfirmPassword] = useState(false);

    let { newpassword, confirmnewpassword } = userData;

    const { id } = useParams();
    const navigate = useNavigate();

    let handleChange = (e) => {
        let { name, value } = e.target;
        var resetData = { ...userData, ...{ [name]: value } };
        delete error[name];
        setUserData(resetData);
        let errMsg = resetInputValidate(resetData, name);
        setError({ ...error, ...errMsg });
    };

    let handleClick = async () => {
        try {
            let errMsg = await resetValidate(userData);
            setError(errMsg);
            if (isEmpty(errMsg)) {
                setisLoad(true);
                var data = {
                    id,
                    newpassword
                }
                let { status, message, } = await resetpassword(data);
                if (status == true) {
                    setisLoad(false);
                    toastAlert("success", message, "reset");
                    setUserData(initialValue)
                    navigate('/')
                } else {
                    setisLoad(false);
                    toastAlert("error", message, "reset");
                }
            }
        } catch (err) {
            console.log(err, "errr");
        }
    };
    return (
        <>
            <MyNavbar />
            <section>
                <Container>
                    <div className="join_sec">
                        <Row>
                            <Col xl="5">
                                <div className="reg_form">
                                    <p className="join_head">Forgot Password</p>
                                    <Form.Group className="mb-4">
                                        <Form.Label className="input_join" htmlFor="inputPassword5">
                                            New Password
                                        </Form.Label>
                                        <InputGroup className="input_group_box">
                                            <Form.Control
                                                className=""
                                                type={!showPassword ? "password" : "text"}
                                                id="inputPassword5"
                                                placeholder="Enter your new password"
                                                aria-describedby="passwordHelpBlock"
                                                name="newpassword"
                                                onChange={handleChange}
                                                value={newpassword}
                                            />
                                            {showPassword ?
                                                <InputGroup.Text id="basic-addon1"
                                                    onClick={() => setShowPassword(!showPassword)}><img
                                                        src={require("../assets/images/eye_open.png")}
                                                        alt="img"
                                                        className="img-fluid "
                                                        width={20}
                                                        height={20}
                                                    /></InputGroup.Text> :
                                                <InputGroup.Text id="basic-addon1"
                                                    onClick={() => setShowPassword(!showPassword)}><img
                                                        src={require("../assets/images/eye_close.png")}
                                                        alt="img"
                                                        className="img-fluid "
                                                        width={20}
                                                        height={20}
                                                    /></InputGroup.Text>}
                                        </InputGroup>
                                        {error && error.newpassword && (
                                            <span style={{ color: "red" }}>{error.newpassword}</span>
                                        )}
                                    </Form.Group>
                                    <Form.Group className="mb-4">
                                        <Form.Label className="input_join" htmlFor="inputPassword5">
                                            Confirm Password
                                        </Form.Label>
                                        <InputGroup className="input_group_box">
                                            <Form.Control
                                                className=""
                                                type={!showconfirmPassword ? "password" : "text"}
                                                id="inputPassword5"
                                                placeholder="Confirm your new password"
                                                aria-describedby="passwordHelpBlock"
                                                name="confirmnewpassword"
                                                onChange={handleChange}
                                                value={confirmnewpassword}
                                            />
                                            {showconfirmPassword ?
                                                <InputGroup.Text id="basic-addon1"
                                                    onClick={() => setShowconfirmPassword(!showconfirmPassword)}><img
                                                        src={require("../assets/images/eye_open.png")}
                                                        alt="img"
                                                        className="img-fluid "
                                                        width={20}
                                                        height={20}
                                                    /></InputGroup.Text> :
                                                <InputGroup.Text id="basic-addon1"
                                                    onClick={() => setShowconfirmPassword(!showconfirmPassword)}><img
                                                        src={require("../assets/images/eye_close.png")}
                                                        alt="img"
                                                        className="img-fluid "
                                                        width={20}
                                                        height={20}
                                                    /></InputGroup.Text>}
                                        </InputGroup>

                                        {error && error.confirmnewpassword && (
                                            <span style={{ color: "red" }}>{error.confirmnewpassword}</span>
                                        )}
                                    </Form.Group>


                                    <Button className="nav_btn mx-auto d-block mt-5" onClick={() => handleClick()}>
                                        Submit{isLoad && <i className="fas fa-spinner fa-spin"></i>}
                                    </Button>
                                </div>
                            </Col>
                            <Col xl="7" className="d-none  d-xl-block">
                                <div className="text-center">
                                    <img src={logo} alt="img" className="img-fluid mx-auto " />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </section >
        </>
    );
}
